<template>
  <span class="breadcrumbs">
    <template v-for="ancestor in breadcrumbs">
      <span class="md-icon">{{ ancestor.getIcon() }}</span>
      <span class="crumb" @click="(e) => ancestor.open(e)">{{
        ancestor.getShortText()
      }}</span>
      <span class="slash">/</span>
    </template>
  </span>
</template>

<style scoped>
.breadcrumbs {
  padding: var(--basic-padding);
  padding-bottom: 0;
}
.md-icon {
  display: inline;
  font-size: 18px;
  vertical-align: bottom;
  padding-right: 4px;
}
.crumb {
  color: var(--link-color);
  cursor: pointer;
}
.crumb:hover {
  text-decoration: underline;
}
.slash {
  padding: 0 6px;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import { REL_ELEM } from "@/structure";

export default {
  props: ["itemID", "layout"],
  components: {},
  computed: {
    breadcrumbs() {
      const result = [];
      let item = getItem(this.itemID);
      if (item.type === "date" || item.type === "dateUnit") return result;
      while (
        item &&
        item[REL_ELEM] &&
        (item = item.cache.get(item[REL_ELEM].key)) &&
        item.type !== "root"
      ) {
        result.push(item);
      }
      return result.reverse();
    },
  },
  methods: {},
};
</script>
